import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  FETCH_RENTAL_INVENTORY_LIST_REQUEST,
  FETCH_RENTAL_INVENTORY_LIST_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import service from 'Api/service';
import { fetchSubrentalsList } from './fetchSubrentalsList';

const fetchRentalInventoryListEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_RENTAL_INVENTORY_LIST_REQUEST),
    debounceTime(500),
    switchMap(({ params }) => {
      // Orders > Subrentals is served by the GraphQL getSubrentals query (TD1-10505).
      if (params.filter === 'subrentals_all') {
        return from(fetchSubrentalsList(params)).pipe(
          map((payload) => ({
            type: FETCH_RENTAL_INVENTORY_LIST_SUCCESS,
            payload,
          })),
          catchError((err) => {
            console.error('fetchRentalInventoryListEpic error', err);
            return of({ type: EPIC_ERROR });
          })
        );
      }

      const {
        filter,
        numberPer: per,
        startDate,
        startDeliveryDate,
        endDeliveryDate,
        endDate,
        showAll: show_all,
        query,
        zone: time_zone_offset,
        page,
        selectedDate: selected_date,
        deliveryType: delivery_type,
        truckIds: truck_ids,
        itemId: item_id,
        productType: product_type,
        rentalStatus: rental_status,
        pickedStatus: picked_status,
        subRentalSource: sub_rental_source,
        sortField: sort_field,
        sortDirection: sort_direction,
        listSortBy: list_sort_by,
        deliveryTime: delivery_time,
        prioritize_sticky,
        multilocationAllLocations: multilocation_all_locations,
        departmentIds: department_ids,
        pickListStatus: pick_list_status,
      } = params;

      const options = {
        per,
        filter,
        selected_date,
        start_date: startDate,
        end_date: endDate,
        time_zone_offset,
        show_all,
        query,
        page,
        delivery_type,
        truck_ids,
        item_id,
        product_type,
        rental_status,
        picked_status,
        sub_rental_source,
        sort_field,
        sort_direction,
        list_sort_by,
        delivery_time,
        start_delivery_time: startDeliveryDate,
        end_delivery_time: endDeliveryDate,
        department_ids,
        pick_list_status,
      };

      if (prioritize_sticky) options.prioritize_sticky = true;
      if (multilocation_all_locations)
        options.multilocation_all_locations = true;

      return from(
        service.get(
          `${import.meta.env.VITE_API_DOMAIN}/api/rental_inventories/paginated`,
          options
        )
      ).pipe(
        map((response) => {
          const payload = {
            rentalInventories: response.data.rentalInventories,
            ...(response.data.meta && {
              pagination: response.data.meta.pagination,
            }),
          };
          return {
            type: FETCH_RENTAL_INVENTORY_LIST_SUCCESS,
            payload,
          };
        }),
        catchError((err) => {
          console.error('fetchRentalInventoryListEpic error', err);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default fetchRentalInventoryListEpic;
